import React, { useState } from 'react';
import type { WindowSize } from '../types';

export function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: 1200,
    height: 800,
  });

  function changeWindowSize() {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  }

  React.useEffect(() => {
    const animationFrame = window.requestAnimationFrame(changeWindowSize);
    window.addEventListener('resize', changeWindowSize);

    return () => {
      window.cancelAnimationFrame(animationFrame);
      window.removeEventListener('resize', changeWindowSize);
    };
  }, []);

  return windowSize;
}
